import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-601fcd76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nr-tabs" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrButton = _resolveComponent("NrButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "nr-tabs-list",
      role: "tablist",
      "aria-label": $props.ariaLabel,
      onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.setupKeyDownEvent && $options.setupKeyDownEvent(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tabs, (tab, index) => {
        return (_openBlock(), _createBlock(_component_NrButton, {
          ref_for: true,
          ref: "tabButtons",
          "aria-controls": tab.id,
          "aria-selected": $options.activeTabId === tab.id,
          variant: "minimal-neutral",
          class: _normalizeClass([
          'nr-tabs-button',
          { 'nr-tabs-button--active': $options.activeTabId === tab.id }
        ]),
          id: `${$data.id}-${tab.id}`,
          key: `${$data.id}-${tab.id}`,
          tabindex: $data.tabFocusIndex === index ? 0 : -1,
          onClick: ($event: any) => ($options.selectTab(tab.id)),
          role: "tab",
          type: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(tab.title), 1)
          ]),
          _: 2
        }, 1032, ["aria-controls", "aria-selected", "class", "id", "tabindex", "onClick"]))
      }), 128))
    ], 40, _hoisted_2),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}